import React from "react";
import {useGetAlertParametersTypeQuery} from "../../../../redux/api/alertParameters";
import {List, Skeleton} from "antd";
import {AlertParametersModel} from "../../../../types/api/alertParameters";
import AlertParametersTypeItem from "./AlertParametersTypeItem";
import {skipToken} from "@reduxjs/toolkit/query";
import {useParams} from "react-router-dom";
import {useGetAssetQuery} from "../../../../redux/api/asset";
import {capitalize} from "lodash";
import {useTranslation} from "react-i18next";

export default function AlertParametersContent() {

  const {assetId} = useParams();
  const {t} = useTranslation();

  const {data: assetData, isLoading: assetDataLoading} = useGetAssetQuery(assetId ? {uuid: assetId} : skipToken)
  const {data: alertParametersTypeData, isLoading: alertParametersTypeDataLoading} = useGetAlertParametersTypeQuery({paginate: false})

  return <>
    <Skeleton active={true} loading={assetDataLoading || alertParametersTypeDataLoading}>
      {assetData && assetData.alert_parameters.length > 0 && <List>
        {assetData && alertParametersTypeData && assetData?.alert_parameters?.map((param: AlertParametersModel, i: number) =>
          <AlertParametersTypeItem param={param}
                                   paramType={alertParametersTypeData.find(type => type.uuid === param.type)}
                                   index={i}/>
        )}
      </List>}
      {assetData && assetData.alert_parameters.length === 0 && capitalize(t('alerts.descriptionNotPresent'))}
    </Skeleton>
  </>
}